import React from "react";
import styled from "styled-components";
import { defineMessages } from "react-intl";
import { FormattedMessage } from "../../../../../../../../components/FormattedMessage";

const messages = defineMessages({
  iAccept: {
    id: "AcceptanceButton.iAccept",
    defaultMessage: "I accept",
  },
});

export function AcceptanceButton({ hideModal }) {
  return (
    <ConfirmButton type="button" onClick={hideModal}>
      <FormattedMessage message={messages.iAccept} />
    </ConfirmButton>
  );
}

const ConfirmButton = styled.button`
  background-color: ${(props) => props.theme.color.buttonPrimary};
  color: ${(props) => props.theme.color.white};
  border-radius: ${(props) => props.theme.layout.borderRadius.md};
  padding-left: ${(props) => props.theme.spacing.lg};
  padding-right: ${(props) => props.theme.spacing.lg};
  padding-top: ${(props) => props.theme.spacing.sm};
  padding-bottom: ${(props) => props.theme.spacing.sm};
  margin-bottom: ${(props) => props.theme.spacing.md};
  font-size: ${(props) => props.theme.typography.typeScale[250]};
  font-weight: ${(props) => props.theme.typography.weight.regular};
  border: none;

  &:active,
  &:focus,
  &:hover {
    background-color: ${(props) => props.theme.color.buttonPrimaryHover};
  }
`;
